module.exports = __webpack_public_path__ + "img/park.1d7cf823.png";